import { FormElement } from './form-element.model';

export class FormElementDateInput extends FormElement {
  public constructor() {
    super();

    this.intialize();
  }

  public intialize = (): void => {
    this.Value = new Date();
    this.ElementTypeId = 6;
  };

  public Value: Date;
}
